export default (t) => [
  {
    text: t('Recipe Name'),
    value: 'name',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Inputs'),
    value: 'inputs',
    sortable: false,
    width: 300,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'active',
    sortable: false,
    width: 50,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 100,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 20
  },
];
